/*
 *  DESERTLAND APP
 *  @author: jd@cals.arizona.edu
 *  @lastModified: Oct 2018
 */


import { DESERTLAND } from './desertland.init';
import { Utils } from './cals.utils';
import { EventBus } from './eventBus'; // replaced radio.js
import DevLogBind from './cals.logBind';
import { Service } from './desertland.service';
import { Controller } from './desertland.controller';
import { Router } from './desertland.router';
import { PageViewModel } from './models/pageViewModel';
// import { TemplateLoader } from './desertland.templateLoader';
import { Templates } from './desertland.templates';
import { Content } from './desertland.content';
import { Plants } from './desertland.plants';
import { PlantSelectorForm } from './desertland.plantSelectorForm';
import { AddThis } from './cals.addthis';

declare var log, info, warn, groupCollapsed, groupEnd, time, timeEnd;

export class AppComponent {

  public gaTitle: string = "Desert Landscaping";
  public currentPage: string = "";
  public shareUrl: string = "";

  public utils: Utils;

  public service: Service;
  public controller: Controller;
  public radio = EventBus;
  
  public templates: Templates;
  public content = Content;
  public plants: Plants; 
  public plantSelectorForm: PlantSelectorForm;
  // public addThis = AddThis; // no need to have this

  public data: any = {
    pages: {}
  };
  public views: any = {};
  public models: any = {};

  public router = new Router().start();//{ hashBang: true } - didnt work

  public config = DESERTLAND.config;

  public VERSION = DESERTLAND.VERSION;
  protected site_root = DESERTLAND.site_root;
  protected credits = DESERTLAND.credits;


  public start = () => {
    time("App:Start");

    this.service = new Service();
    this.controller = new Controller();
    this.templates = new Templates();
    this.plants = new Plants();
    this.plantSelectorForm = new PlantSelectorForm();
    
    //create dev functions
    // tslint:disable-next-line:no-string-literal
    window['dev'] = DevLogBind;
    // tslint:disable-next-line:triple-equals
    if (process.env.NODE_ENV === 'production' && this.service.localStorageAPI.get("consoul",false) != "1") {// eslint-disable-line eqeqeq
      DevLogBind('disableLogs',true);//this is on App Start, skip the localstorage step
    }
    
    
    this.models.pageView = new PageViewModel();

    this.service.load.pages((data) => {
      groupCollapsed("Page data");
      log("pages data ready");
      this.data.pages = data;
      // this.radio.$emit('dataPagesReady', data);
      this.radio.publish('dataPagesReady', data);
      groupEnd("Page data");
    });

    // start'er up!
    
    this.router.start();
    
    
    //DESERTLAND.radio('testRadioEvent').subscribe(function(){log("airwaves");}).broadcast();
  
    window['DESERTLAND-search'] = this.plants.search; // handle action from template
      
      
    timeEnd("App:Start");
  }//end App.prototype.start

}


export const onDomReady = () => {
  // log("app: onDomReady");
  App.radio.publish('dom:ready');
  
  App.templates.init();

  // this includes the drawers , so don't need:
  // init nav drawers (& basket)
  //DESERTLAND.initRightDrawer();
  //DESERTLAND.initLeftDrawer();
  
  // sticky subnav
  //DESERTLAND.initStickySubnav();// do this on the pages first


  // load content - if on that page (App.currentPage)
  // info(App.currentPage);
  // DESERTLAND.models.pageView.set("page",App.currentPage);
  // switch (App.currentPage) {
  //     case "index":
  //         //info("loadIndex");
  //         break;
      
  //     case "plants":
  //         //DESERTLAND.Plants.init(); // do in controller
  //         break;
      
  //     case "tips":
  //         //DESERTLAND.Content.Tips.init();
  //         break;
  // }

    
};//end App.prototype.onDomReady



export function initStickySubnav (sel) {
    sel = sel || "#sticky_subnav";
    if ($(sel).length) {
        //info("initStickySubnav > ",sel);
        info("TODO: initStickySubnav > new library.");
        // https://github.com/senff/Sticky-Anything - TODO: there's no destroy() method, we need to find a new library - causing a memory leak when nav pages...
        // $(sel).stickThis({
        //     top:        52,      // top position of sticky element, measured from 'ceiling'
        //     minscreenwidth: 700,      // element will not be sticky when viewport width smaller than this
        //     maxscreenwidth: 999999,     // element will not be sticky when viewport width larger than this 
        //     zindex:     20,      // z-index value of sticky element
        //     debugmode:  true   // when true, errors will be logged to console
        // });
    } else {
        info("initStickySubnav SEL not found",sel);
    }
}


export const App = new AppComponent();








